import classNames from 'classnames';
import React from 'react';

import Trans from 'components/Common/Translation/Trans';
import ModalPageContent from 'components/Modals/ModalPageContent/ModalPageContent';
import { useModal } from 'hooks/useModal';
import { apiUrls } from 'services/api-urls';

export default function CheckoutSummaryCgv({
  classes,
}: CheckoutSummaryCgvType): JSX.Element {
  const { open, openModal, closeModal } = useModal();
  const cgvUrl = apiUrls.getMediaPopin('/15.html');

  function handleClick(ev: React.MouseEvent<HTMLAnchorElement>) {
    ev.preventDefault();
    openModal();
  }

  return (
    <div className={classNames(classes?.wrapper)}>
      <Trans
        i18nKey={'LABEL_ORDER_CGV'}
        namespace={'checkout'}
        additionalComponents={{
          Link: <a href={cgvUrl} onClick={handleClick} />,
        }}
      />
      <ModalPageContent
        isOpen={open}
        closeModal={closeModal}
        pageUrl={cgvUrl}
      />
    </div>
  );
}

type CheckoutSummaryCgvType = {
  classes?: CheckoutSummaryCgvClassesType;
};

type CheckoutSummaryCgvClassesType = {
  wrapper?: string;
};
